import {parseCSS} from './util.js';
import createElementPlus from './util/createElementPlus.js'

/**
 * 2023-10-17 This is the non-jQuery version
 * StyleControls constructor
 * used by both layer-style and feature-style controls
 * params: {on-change handler functions}
 * returns an object with:
 *    controls - div containg the controls
 *    setVals() - sets controls to values
 *    setFillOpacity() - sets the fillopacity value and fires the handler function
 * called from
 *    ToolManager.js:64 > Draw.js:29 > LayerStyles.js:59
 *    ToolManager.js:86 > ModifyVectorFeaturre.js:27 > FeatureStyleControls.js:237
 */

export default function(handlers) {

  const prefix = handlers.prefix
  // data-feature-div id="featureDiv" look suspicious here. What about "layer"?
  const controlsHTML = `
<div data-feature-div="" id="featureDiv" style="">
  <div id="stylecontrols">
    <div class="style-controls">
      <hr>
      <div style="font-weight: bold; font-size: larger;">Font Style</div>
      Size: &nbsp;
      <select id="${prefix}fontsize">
        <option value="6pt">6 point</option>
        <option value="8pt">8 point</option>
        <option value="10pt">10 point</option>
        <option value="12pt">12 point</option>
        <option value="14pt">14 point</option>
        <option value="18pt">18 point</option>
        <option value="24pt">24 point</option>
      </select>
      <br>
      Family: &nbsp;
      <select id="${prefix}fontfamily">
        <option value="sans-serif">Sans-serif</option>
        <option value="Arial">Arial</option>
        <option value="Serif">Serif</option>
        <option value="Times New Roman">Times New Roman</option>
        <option value="Courier New">Courier New</option>
      </select>
      <br>
      Weight: &nbsp;
      <select id="${prefix}fontweight">
        <option value="normal">Normal</option>
        <option value="bold">Bold</option>
      </select>
      <br>
      <label for="${prefix}fontcolor">Color (click to change) </label>
      <input id="${prefix}fontcolor" type="color">
      <br>Outline width: &nbsp;
      <select id="${prefix}fontoutlinewidth">
        <option value="0">none</option>
        <option value="1">1</option>
        <option value="2">2</option>
        <option value="3">3</option>
        <option value="4">4</option>
        <option value="5">5</option>
        <option value="6">6</option>
      </select>
      <br>
      <label for="${prefix}fontoutlinecolor">Outline Color (click to change) </label>
      <input id="${prefix}fontoutlinecolor" type="color">
      <div id="style-line" class="style-controls" style="display: none;">
        <hr>
        <div style="font-weight: bold; font-size: larger;">Line Style</div>
        <label for="${prefix}linecolor">Line Color (click to change)
        </label><input id="${prefix}linecolor" type="color">
        <br>
        <label for="${prefix}linewidth">Line width: </label>
        <select id="${prefix}linewidth">
          <option value="1">1</option>
          <option value="2">2</option>
          <option value="3">3</option>
          <option value="4">4</option>
          <option value="5">5</option>
          <option value="6">6</option>
          <option value="8">8</option>
        </select>
        <br>
        <label for="${prefix}lineopacity">Line opacity: </label>
        <input id="${prefix}lineopacity" type="range" min="0" max="1" step="0.1">
      </div>
      <div id="style-poly" class="style-controls">
        <hr>
        <div style="font-weight: bold; font-size: larger;">Polygon Style</div>
        <label for="${prefix}outlinecolor">Outine Color (click to change) </label>
        <input id="${prefix}outlinecolor" type="color">
        <br>
        <label for="${prefix}outlinewidth">Outline width: </label>
        <select id="${prefix}outlinewidth">
          <option value="1">1</option>
          <option value="2">2</option>
          <option value="3">3</option>
          <option value="4">4</option>
          <option value="5">5</option>
          <option value="6">6</option>
          <option value="8">8</option>
        </select>
        <br>
        <label for="${prefix}outlineopacity">Outine opacity: </label>
        <input id="${prefix}outlineopacity" type="range" min="0" max="1" step="0.1">
        <br>
        <label for="${prefix}fillcolor">Fill Color (click to change) </label>
        <input id="${prefix}fillcolor" type="color">
        <br>
        <label for="${prefix}fillopacity">Fill opacity: </label>
        <input id="${prefix}fillopacity" type="range" min="0" max="1" step="0.1" value=0><br>
        <label for="${prefix}addring">Cut a hole in the polygon: </label>
        <input id="${prefix}addring" type="button" value="Cut">
        <hr>
      </div>
    </div>
  </div>
</div>`

/*
  // StyleContols can be used either for an individal feature
  //   or for a layer. The prefix will be either 'feature-' or 'layer-'
  //   The prefix is prepended to each div's id. "layer-" is probably only used in cpc
  // let controlsHTML_withPrefix = controlsHTML.replaceAll('ID_PREFIX-', handlers.prefix)
  // 2023-12-22 above .replaceAll() not supported in Chrome v84.0 which is on the
  // Wyoming Assessor's Chromebooks so use below
  let controlsHTML_withPrefix = controlsHTML.replace(new RegExp('ID_PREFIX-', 'g'), handlers.prefix)
*/

  const controls = createElementPlus('div', {
    classes: ['style-controls'],
    innerHTML: controlsHTML,
  })

  for (const h in handlers) {
    const element = controls.querySelector('#' + prefix + h)
    if (element) { // handler matches an element.id so add the handler to the element
      if (element.tagName === 'SELECT') {
        element.addEventListener('change', handlers[h])  // onChange for <SELECT>
      } else if (element.tagName === 'INPUT') {
        if (element.type === 'button') {
          element.addEventListener('click', handlers[h])
        } else {
          element.addEventListener('input', handlers[h])  // onInput for <INPUT>
        }
      } else {
        console.warn('Unhandled tagName:', element.tagName )
      }
    } else { // handler does not match any element.id so handler needs be added to a group of elements

      switch (h) {
        case 'prefix': // throw this away
          break
        case 'font':
          controls.querySelectorAll(`select[id^='${handlers.prefix}font']`).forEach(control => {
            control.addEventListener('change', handlers[h])
          })
          break
        case 'colorpicker':
          controls.querySelectorAll("input[type=color]").forEach(control => {
            control.addEventListener('input', handlers[h])
          })
          break
        default:
          console.warn('Unknown handler', h)
          break
      } // switch
    }
  } // for h in handlers

  this.controls = controls

  this.setVals = function(vals) {
    const me = this
    const prefix = handlers.prefix

    // FeatureStyle passed the font object instead of fontsize, fontweight, fontfamily, etc.
    if (vals.font) {
      const parsedFont = parseCSS('font: ' + vals.font);
      if (parsedFont['fontSize'])   vals['fontsize']   = parsedFont['fontSize']    // 1em
      if (parsedFont['fontFamily']) vals['fontfamily'] = parsedFont['fontFamily']  // verdana, sans-serif
      if (parsedFont['fontWeight']) vals['fontweight'] = parsedFont['fontWeight']  // bold
    }

    this.controls.querySelectorAll('[id]').forEach(node => {
      if (node.id.indexOf(prefix) === 0) {
        const control = node.id.split('-')[1]
        if (vals[control]) {  // is there a value for this control?
          me.controls.querySelector(`#${node.id}`).value = vals[control]
        }
      }
    })
  };

  // this is called by setFillColor() when opacity == 0
  // it sets the control and also fires the handler thanks to the trailing change()
  this.setFillOpacity = function(opacity) {
    // fillopacity.val(opacity).change();
    this.controls.querySelector(`[id$="fillopacity"]`).value = opacity
  };
}
